/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Discount_LabelInputs */

const vi_product_lot_discount_label = /** @type {(inputs: Product_Lot_Discount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CK lô (%)`)
};

/**

* @param {Product_Lot_Discount_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_discount_label = /** @type {((inputs?: Product_Lot_Discount_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Discount_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_discount_label(inputs)
});